'use strict';

document.addEventListener('DOMContentLoaded', function () {

    var _AGB_RECS_DEBUG = false;
    var console = (_AGB_RECS_DEBUG && typeof window !== 'undefined' && window.console)
        ? window.console
        : { log: function(){}, warn: function(){}, info: function(){}, error: function(){} };

    // Define the itemsToRemove at the top level
    var itemsToRemove = [
        "Plate Carrier Giveaway",
        // BYPASS (kept out of the hide-list ON PURPOSE): "Become a gear tester" must ALWAYS
        // show in the header. updateMainNav() below removes any nav item whose data-title is
        // in this list once recommendations run (i.e. for returning/known visitors), which is
        // why it used to disappear. Leaving it commented out keeps the CTA permanently visible.
        // "Become a gear tester",
        "Military/LE Discount",
        "Mil/LE Discount",
        "About Us",
        "Magnetix Battle Belt Giveaway"
    ];
      // Check if visitorID was generated in this session
    const visitorIdGeneratedThisSession = sessionStorage.getItem('visitorIdGeneratedThisSession') === 'true';

    // Check if recommendation fetch previously failed
    const recommendationFetchFailed = sessionStorage.getItem('recommendationFetchFailed') === 'true';

    // Function to generate a unique visitor ID (UUID)
    function generateUUID() {
      var d = new Date().getTime();
      var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
  
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (Math.random() * 16) | 0;
  
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else if (d2 > 0) {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
  
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

    // Function to set a cookie
    function setCookie(name, value, days) {
      if (!value || value === "1") {
          console.error("Invalid visitorID assigned:", value);
          return;
      }
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
        // keep localStorage in sync with cookie
    if (name === 'visitorID') {
        localStorage.setItem('visitorID', value);
    }
}

    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i].trim();
          if (c.indexOf(nameEQ) == 0) {
              var value = c.substring(nameEQ.length, c.length);
              if (value === "1") {
                  console.warn("Detected invalid visitorID '1', removing...");
                  deleteCookie(name);
                  return null;
              }
              return value;
          }
      }
      return null;
}

// Ensure localStorage mirrors the cookie when cookie exists
function syncVisitorIDFromCookie() {
  var c = getCookie('visitorID');
  if (c && localStorage.getItem('visitorID') !== c) {
    localStorage.setItem('visitorID', c);
  }
}

    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    // Get the email parameter from the URL
    function getEmailFromURL() {
      var urlParams = new URLSearchParams(window.location.search);
      // `bde` first: the IL geo-redirect deletes a parameter named "email"
      // outright (measured 2026-09-16), so campaign links carry the address
      // under that name too. Older links still only have `email`.
      var email = urlParams.get('bde') || urlParams.get('email');
      if (email) {
          email = email.replace(/\s/g, '+');  // Replace any spaces with "+"
      }
      console.log("Email:", email);  // Log the email before returning it
    return email;  // Return the email
}

    // Main logic to check or set visitorID
var visitorID = getCookie('visitorID');  // Check if visitorID is already stored in a cookie
syncVisitorIDFromCookie();
var email = getEmailFromURL();  // Get the email parameter from the URL

if (!visitorID && email) {
        // Landing from an email link with no identity yet: mint the vid so
        // signup-vid-link.js can link it to the email (source=email_click ->
        // vid-email-resolve -> users_drip). The old database-app-1
        // /save-visitor rebind is RETIRED: it double-captured the link and
        // adopted a server visitor id over this one (cookie clobber).
        visitorID = generateUUID();
        setCookie('visitorID', visitorID, 300);
        localStorage.setItem('visitorID', visitorID);

        sessionStorage.setItem('visitorIdGeneratedThisSession', 'true');
}

    // ── Country resolution (end-to-end) ──────────────────────────────────────
    // localStorage['country'] is what the TTB country patch, best-seller, and
    // returning-user flows read. /get-recommendations (the Cloud Run recs
    // service, no geoip - same as database-app-1 before it) returns no country
    // for a fresh visitor. /api/whoami (the Cloud Run whoami service,
    // GeoLite2-Country) resolves it — that's the reliable source. Run it on
    // every load: no-op once
    // a real country is cached, fail-open, treats the legacy "null"/"undefined"
    // strings as empty so previously-poisoned visitors re-resolve.
    (function ensureCountryResolved() {
        try {
            var cur = localStorage.getItem('country');
            if (cur && cur !== 'null' && cur !== 'undefined') return;

            var writeName = function (name, src) {
                try {
                    if (!name) return;
                    localStorage.setItem('country', name);
                    try { console.log('[country] resolved from ' + src + ':', name); } catch (e) {}
                } catch (e) {}
            };
            // Shopify yields ISO codes ("US"); the cross-store vocabulary is full
            // NAMES ("United States" — TTB maps, CAE column, best-seller flows).
            // Convert via the browser-built-in Intl.DisplayNames; when that's not
            // possible fall through to whoami rather than mix vocabularies.
            var toName = function (codeOrName) {
                var s = String(codeOrName || '').trim();
                if (!s) return null;
                if (s.length !== 2) return s; // already a display name
                try {
                    var n = new Intl.DisplayNames(['en'], { type: 'region' }).of(s.toUpperCase());
                    return (n && n.toUpperCase() !== s.toUpperCase()) ? n : null;
                } catch (e) { return null; }
            };
            // Pass the (already-adopted) visitorID so a FAKE id (facade00-) resolves
            // to its panel-set country here too — otherwise whoami returns the
            // impersonating operator's real geoip country and races the
            // /get-recommendations fake-country write. Harmless for real ids
            // (region_persist=0 → no IP mirror write either way).
            var _vid = '';
            try { _vid = localStorage.getItem('visitorID') || ''; } catch (e) {}
            var whoamiFallback = function () {
                try {
                    var _wurl = 'https://whoami-432657747828.europe-west1.run.app/api/whoami?region_enabled=1&region_persist=0'
                        + (_vid ? '&visitorID=' + encodeURIComponent(_vid) : '');
                    fetch(_wurl)
                        .then(function (r) { return r.ok ? r.json() : null; })
                        .then(function (w) { writeName(w && w.country, 'geoip'); })
                        .catch(function () { /* fail-open: no country -> default patch */ });
                } catch (e) {}
            };

            // FAKE customers must NOT use Shopify-native geo — their country is
            // panel-SET and only whoami knows it; Shopify would return the
            // impersonating operator's real location.
            if (_vid.indexOf('facade00-') === 0) { whoamiFallback(); return; }

            // Priority (user decision 2026-07-05): SHOPIFY-NATIVE first —
            // window.Shopify.country (the buyer's Markets country), else
            // Shopify's own IP-geo endpoint — and only then our whoami.
            var marketName = null;
            try { if (window.Shopify && window.Shopify.country) marketName = toName(window.Shopify.country); } catch (e) {}
            if (marketName) { writeName(marketName, 'shopify-market'); return; }

            fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (d) {
                    // Shopify has varied this response shape over time — same
                    // defensive extraction as the TTB resolver.
                    var code = d && (
                        (d.detected_values && d.detected_values.country && (d.detected_values.country.handle || d.detected_values.country.value)) ||
                        d.country_code ||
                        (Array.isArray(d.suggestions) && (d.suggestions.filter(function (s) { return s && (s.part === 'country' || s.part === 'country_code'); })[0] || {}).value)
                    ) || null;
                    var name = toName(code);
                    if (name) writeName(name, 'shopify-geo'); else whoamiFallback();
                })
                .catch(whoamiFallback);
        } catch (e) {}
    })();

     // Check if recommendations and country/tande data are already in localStorage
const THIRTY_DAYS_MS = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
const recommendationFetchTime = localStorage.getItem('recommendationFetchTime');

function waitForResolvedVisitorId(timeoutMs) {
    return new Promise(function (resolve) {
        // Already resolved? Take it.
        try {
            if (window.SE_visitorIdentity && window.SE_visitorIdentity.visitor_id) {
                resolve(window.SE_visitorIdentity.visitor_id);
                return;
            }
        } catch (e) {}
        var done = false;
        function finish(id) {
            if (done) return;
            done = true;
            window.removeEventListener('SE_visitorIdentified', onEvent);
            resolve(id || null);
        }
        function onEvent(e) {
            var id = e && e.detail && e.detail.visitor_id;
            finish(id || null);
        }
        window.addEventListener('SE_visitorIdentified', onEvent);
        // Timeout = fall back to whatever's in localStorage.
        setTimeout(function () {
            finish(localStorage.getItem('visitorID'));
        }, timeoutMs);
    });
}

function fetchRecommendationsFor(canonicalVisitorId) {
    if (!canonicalVisitorId) {
        console.error("VisitorID not found after group resolution.");
        sessionStorage.setItem('recommendationFetchFailed', 'true');
        return;
    }
    var lastCachedFor = localStorage.getItem('recommendationFetchVisitorId');
    localStorage.setItem('visitorID', canonicalVisitorId);

    // ── recommendations now come from the color-pref bake (2026-08-24) ──
    // Same wire shape, served from memory (~50ms vs the Render+MySQL CTE).
    // The legacy call below still runs for country/tande — but its
    // recommendedProducts only land as a FALLBACK when this source had
    // nothing for the visitor. Fakes (facade00-) use this source TOO since
    // 2026-08-24: the service answers them from the panel profile (colour,
    // per-product variants), so simulator and shopper run ONE code path.
    // Kill switch: window.AGB_RECS_SOURCE_OFF.
    var recsFromNewSource = false;
    var newRecsReady = Promise.resolve(false);
    if (!window.AGB_RECS_SOURCE_OFF) {
        var recsUrl = window.AGB_RECS_URL ||
            'https://color-pref-432657747828.europe-west1.run.app/get-recommendations';
        // The page updates chain on this verdict, so it must SETTLE fast even
        // when the service stalls: 4s race -> legacy verdict; a late table
        // answer still writes storage below and owns the NEXT page load.
        var recsVerdictTimeout = new Promise(function (resolve) {
            setTimeout(function () { resolve(false); }, 4000);
        });
        var recsFetch = fetch(recsUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visitorID: canonicalVisitorId })
        })
        .then(function (r) { return r.json(); })
        .then(function (d) {
            if (d && d.success && d.known && Array.isArray(d.recommendedProducts) &&
                d.recommendedProducts.length) {
                localStorage.setItem('recommendedProducts', JSON.stringify(d.recommendedProducts));
                // Which source produced what's in storage - read by the CAE
                // rec_state snapshot so evaluation can split table vs legacy.
                localStorage.setItem('recommendedSource', 'table');
                // Stamp here as well: the stamp used to live only in the legacy
                // branch, so a table-only success left the cache looking unfetched.
                _stampFetch(canonicalVisitorId);
                recsFromNewSource = true;
                console.log('Recommendations served by color-pref (' +
                    d.recommendedProducts.length + ' products)');
            }
            return recsFromNewSource;
        })
        .catch(function () { return false; });   // unreachable -> legacy fills in
        newRecsReady = Promise.race([recsFetch, recsVerdictTimeout]);
    }

    // ── The apply is no longer owned by the legacy backend ──────────────────
    // executePageUpdates used to be reachable ONLY from inside the legacy
    // fetch's success branch. So when the TABLE source answered and the legacy
    // dyno was cold or down, the fresh list was written to storage and NOTHING
    // was rendered - and because the fetch stamp lived in that same branch, the
    // cache fast-path never engaged either, so it repeated every load for the
    // whole outage. These three pieces make the apply independent of it.
    var _applied = false;
    function _applyOnce(list, tande, country) {
        if (_applied) return;
        if (!Array.isArray(list) || !list.length) return;
        _applied = true;
        executePageUpdates(list, tande, country);
    }
    function _stampFetch(vid) {
        try {
            localStorage.setItem('recommendationFetchTime', Date.now());
            if (vid) localStorage.setItem('recommendationFetchVisitorId', vid);
        } catch (e) {}
    }
    // Safety net: whatever ends up in storage gets applied even if the legacy
    // call never resolves. Runs after the 4s source race has settled.
    setTimeout(function () {
        if (_applied) return;
        var stored = null;
        try { stored = JSON.parse(localStorage.getItem('recommendedProducts') || 'null'); }
        catch (e) { stored = null; }
        if (Array.isArray(stored) && stored.length) {
            _applyOnce(stored, localStorage.getItem('tande'), localStorage.getItem('country'));
        }
    }, 4600);

    fetch('https://recommendations-432657747828.europe-west1.run.app/get-recommendations', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            visitorID: canonicalVisitorId
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            console.log("Recommended products and country/tande data fetched and stored in localStorage");
            // Store recommendations, country, and tande in localStorage.
            // The color-pref source OWNS recommendedProducts when it answered —
            // wait for its verdict so the slower call can never overwrite the
            // faster one (a race, not a priority, decided this before).
            newRecsReady.then(function (newSourceWon) {
                // Array-guard: a degraded backend answering {success:true} with
                // no recommendedProducts stored the STRING "undefined", and
                // every later JSON.parse of the cache then threw - bricking
                // personalization for that browser permanently.
                if (!newSourceWon && Array.isArray(data.recommendedProducts)) {
                    localStorage.setItem('recommendedProducts', JSON.stringify(data.recommendedProducts));
                    localStorage.setItem('recommendedSource', 'legacy');
                }
                // The VISIBLE updates must follow the same verdict as storage.
                // Before this, executePageUpdates always ran with the legacy
                // array - so a table win reordered the page with legacy recs
                // for one load, and storage/UI disagreed until the next page.
                var recsToApply = Array.isArray(data.recommendedProducts) ? data.recommendedProducts : [];
                if (newSourceWon) {
                    try {
                        var stored = JSON.parse(localStorage.getItem('recommendedProducts') || 'null');
                        if (Array.isArray(stored) && stored.length) recsToApply = stored;
                    } catch (e) { /* fall back to the legacy array */ }
                }
                _applyOnce(recsToApply, data.tande, data.country);
            });
            // /get-recommendations runs on database-app-1, where geoip is DISABLED,
            // so data.country is null for any visitor without a stored country.
            //   (a) NEVER store the literal "null" string (old bug: it made the
            //       re-fetch guard think a country was set and never retry).
            //   (b) Fall back to /api/whoami on database-app-2 (geoip ENABLED — it
            //       now returns `country` from the cached GeoLite2-Country DB) so
            //       localStorage['country'] is populated THIS load. The TTB country
            //       patch, best-seller, and returning-user flows all read it.
            // Only store a REAL country (never the literal "null"). The geoip
            // fallback when /get-recommendations has none is handled once, up
            // front, by ensureCountryResolved() — don't duplicate it here.
            if (data.country) {
                localStorage.setItem('country', data.country);
            }
            localStorage.setItem('tande', data.tande);
            _stampFetch(canonicalVisitorId);
            // executePageUpdates moved into the newRecsReady handler above, so
            // the applied recs always match the source that owns storage.
        } else {
            console.error("Error fetching recommendations:", data.message);
            sessionStorage.setItem('recommendationFetchFailed', 'true');
        }
    })
    .catch(error => console.error("Error fetching recommendations:", error));
}

var lastCachedFor = localStorage.getItem('recommendationFetchVisitorId');
var cachedRecs = localStorage.getItem('recommendedProducts');
var needFreshFetch = (
    (!visitorIdGeneratedThisSession &&
     !recommendationFetchFailed &&
     !cachedRecs) ||
    cachedRecs === '[]' ||
    !localStorage.getItem('country') ||
    localStorage.getItem('country') === 'null' ||
    localStorage.getItem('country') === 'undefined' ||
    !recommendationFetchTime ||
    (Date.now() - parseInt(recommendationFetchTime) > THIRTY_DAYS_MS)
);

// Late-identity watchdog. If the engine's _bootVisitorIdentity takes longer
// than waitForResolvedVisitorId's 2s timeout (Render cold-start, slow
// network), we'll have fetched recs for whatever was in localStorage at
// that moment. The engine eventually resolves the canonical id and sets
// window.SE_visitorIdentity / dispatches SE_visitorIdentified. This
// watchdog catches that late arrival, refetches for the canonical id,
// and re-applies. Without it, the page renders wrong recs until the next
// navigation triggers the cache-mismatch self-heal.
function _watchLateIdentity(initialFetchedId) {
    if (!initialFetchedId) return;
    var fired = false;
    function reactToLate(lateId) {
        if (fired) return;
        if (!lateId || lateId === initialFetchedId) return;
        fired = true;
        window.removeEventListener('SE_visitorIdentified', listener);
        fetchRecommendationsFor(lateId);
    }
    function listener(e) {
        reactToLate(e && e.detail && e.detail.visitor_id);
    }
    window.addEventListener('SE_visitorIdentified', listener);
    // Catch the case where the event fired BETWEEN our 2s timeout and now
    // (the window.SE_visitorIdentity cache is set inside the engine right
    // before dispatchEvent, so checking it on next tick is reliable).
    setTimeout(function () {
        var w = window.SE_visitorIdentity;
        if (w && w.visitor_id) reactToLate(w.visitor_id);
    }, 0);
    // Bound the listener lifetime so it doesn't leak past the engine's
    // cold-start window. 30s is generous; identify rarely takes more than
    // 10-15s even on a fully cold Render dyno.
    setTimeout(function () {
        window.removeEventListener('SE_visitorIdentified', listener);
    }, 30000);
}

if (needFreshFetch) {
    waitForResolvedVisitorId(2000).then(function (resolvedId) {
        var fetchedId = resolvedId || visitorID;
        fetchRecommendationsFor(fetchedId);
        _watchLateIdentity(fetchedId);
    });
} else {
    waitForResolvedVisitorId(2000).then(function (resolvedId) {
        if (resolvedId && lastCachedFor && resolvedId !== lastCachedFor) {
            fetchRecommendationsFor(resolvedId);
            _watchLateIdentity(resolvedId);
            return;
        }
        // Cache is valid -- run page updates with stored data. Self-healing:
        // a cache poisoned by an older build (the literal string "undefined")
        // is dropped rather than thrown on, so the next load re-fetches.
        var _cached = null;
        try { _cached = JSON.parse(cachedRecs); } catch (e) { _cached = null; }
        if (Array.isArray(_cached) && _cached.length) {
            executePageUpdates(_cached, localStorage.getItem('tande'), localStorage.getItem('country'));
        } else {
            try { localStorage.removeItem('recommendedProducts'); } catch (e) {}
        }
        // Still watch for a late identity update -- the engine might come
        // back with a DIFFERENT id than what we cached for (e.g. ip-match
        // on this device replaces what localStorage had). When it does,
        // refetch and re-apply with the canonical id.
        _watchLateIdentity(resolvedId || lastCachedFor || visitorID);
    });
}
localStorage.setItem('visitorID', visitorID);
if (!visitorID) {
    visitorID = generateUUID();
    sessionStorage.setItem('visitorIdGeneratedThisSession', 'true');
    setCookie('visitorID', visitorID, 300);
    localStorage.setItem('visitorID', visitorID);

}
if (visitorID) {
  // Locale-aware root: every theme fetch is prefixed (IL serves English under
  // /en), so an unprefixed cart URL can hit the wrong locale.
  function _root() {
    try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    catch (e) { return '/'; }
  }

  const attributes = {
    visitorID: visitorID
  };

  // Try adding recommended products if available
  try {
    const recs = localStorage.getItem('recommendedProducts');
    if (recs && recs !== '[]') {
      const parsedRecs = JSON.parse(recs);
      parsedRecs.forEach((product, index) => {
        // No optional chaining here: recommendations.js loads raw (no
        // transpile step), and optional chaining on `product` is a parse error
        // on older browsers (iOS 12 Safari, Chrome 79) that kills the whole file.
        if (product && product.productName) {
          attributes[`Rec${index + 1}`] = product.productName;
        }
      });
    }
  } catch (err) {
    console.error("Error parsing recommendedProducts from localStorage:", err);
  }

  // COMPARE, THEN WRITE. This used to POST a cart mutation on EVERY page view,
  // whether or not anything had changed. The attributes must still update when
  // the recommendation list changes mid-session (they ride the order), so a
  // once-per-session flag would be wrong - instead read the cart first and skip
  // the write when every attribute already matches.
  fetch(_root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var current = (cart && cart.attributes) || {};
      var same = true;
      for (var k in attributes) {
        if (!Object.prototype.hasOwnProperty.call(attributes, k)) continue;
        if (String(current[k] === undefined ? '' : current[k]) !== String(attributes[k])) { same = false; break; }
      }
      if (same) return null;                       // nothing to say - no mutation
      return fetch(_root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    })
    .then(function (res) {
      if (!res) return null;                      // skipped: attributes already match
      return res.json().then(function (cart) {
        console.log('Cart attributes updated:', cart && cart.attributes);
        return cart;
      });
    })
    .catch(function (err) { console.error('Could not set cart attributes:', err); });
}
    // Function to execute all page updates. Each sub-call is independently
    // wrapped so a thrown error in one doesn't prevent the others (reorder,
    // nav update,
    // tande gate) from running. Validates recommendedProducts is an array
    // up-front; downstream code assumes that.
    // SEAM for reco-session.js (the session blender): lets the session-adjusted
    // list re-render through the SAME surfaces + panel gates as the offline
    // list, without duplicating any reorder logic outside this closure.
    // (function declarations hoist, so assigning before the definition is fine)
    window.__AGB_applyRecs = function (recs, tande, country) {
        window.__AGB_applyingSession = true;
        try { executePageUpdates(recs, tande, country); } catch (e) { console.warn('applyRecs seam failed', e); }
        finally { window.__AGB_applyingSession = false; }
    };

    function executePageUpdates(recommendedProducts, tande, country) {
        if (!Array.isArray(recommendedProducts)) recommendedProducts = [];
        // Announce the apply so the session blender can re-blend when an
        // OFFLINE apply lands after its own (slow-fetch pages). detail.session
        // marks the blender's own applies so it never reacts to itself.
        try {
            document.dispatchEvent(new CustomEvent('agb:recs-applied', {
                detail: { session: window.__AGB_applyingSession === true }
            }));
        } catch (e) {}
        // PREVIEW-ONLY explainer toast via the engine's existing machinery
        // (debugToastsEnabled is itself preview-gated; the role check is
        // belt-and-braces - this must NEVER render on the published theme).
        try {
            var _role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
            var _eng = window.SE_Engine;
            if (_role !== 'main' && _eng && _eng.debugToastsEnabled && typeof _eng._emitInfoToast === 'function') {
                var _isSession = window.__AGB_applyingSession === true;
                var _srcTxt;
                if (_isSession) {
                    var _bi = window.__AGB_sessionBlendInfo || null;
                    _srcTxt = 'SESSION blend' + (_bi ? ' (viewed ' + _bi.trail + ', cart ' + _bi.cart + ')' : '');
                } else {
                    var _s = 'legacy';
                    try { _s = localStorage.getItem('recommendedSource') || 'legacy'; } catch (e2) {}
                    _srcTxt = _s === 'table' ? 'OFFLINE (new table source)' : 'OFFLINE (legacy source)';
                }
                var _top = recommendedProducts.slice(0, 3)
                    .map(function (p) { return p && p.productLink; }).filter(Boolean).join(', ');
                _eng._emitInfoToast('recoApplied', 'RECO',
                    recommendedProducts.length + ' recommendations applied - ' + _srcTxt +
                    ' - reordered products/collections + images. Top: ' + _top,
                    { source: 'reco', kind: 'info' });
            }
        } catch (e) {}
        // The panel's per-surface switches (window.__AGB_dynamicUI, published by
        // theme.liquid) were written and read by NOTHING - so none of these
        // surfaces had a working kill switch. Default ON when unresolved, which
        // is the documented contract.
        function _on(key) {
            try {
                var d = window.__AGB_dynamicUI;
                if (!d) return true;
                var f = d.features || d;
                return f[key] !== false;
            } catch (e) { return true; }
        }
        if (_on('nav')) { try { updateMainNav(); } catch (e) { console.warn('updateMainNav failed', e); } }
        // try { updateAnnouncementBar(country); } catch (e) {}
        try { hideSectionIfTandeIs1(tande); } catch (e) { console.warn('hideSectionIfTandeIs1 failed', e); }
        if (_on('productReorder')) { try { reorderProductList(recommendedProducts); } catch (e) { console.warn('reorderProductList failed', e); } }
        if (_on('collectionReorder')) { try { reorderCollections(recommendedProducts); } catch (e) { console.warn('reorderCollections failed', e); } }
        // try { updateSlideshow(recommendedProducts[0]); } catch (e) {}
        // The card IMAGE pass was DELETED 2026-08-26. colour-cards.js owns card
        // imagery now: one baked colour map, idempotent, layout-pinned, and it
        // paints the SHOPPER'S colour. This pass painted the same pixels from a
        // different source (one Storefront API call PER CARD, answering a
        // different question - the RECOMMENDED product's colour), so whichever
        // finished last won and a colour that was already set could flip.
        // One owner, by construction.
        // try { revealBadgesByPositions(recommendedProducts, [0,2,3]); } catch (e) {}
    }
    // Function to update the main navigation
    function updateMainNav() {
        console.log("Updating Navigation...");

        var navItems = document.querySelectorAll('.header__primary-nav-item');
        navItems.forEach(function(item) {
            var title = item.getAttribute('data-title');
            if (typeof title === 'string' && itemsToRemove.includes(title)) {
                item.remove();  // Remove the item if its title matches
            }
        });

        // Add collections to the navigation
        var collectionsToAdd = [
            { name: "Plate Carrier Accessories", url: "/collections/plate-carrier-accessories" },
            { name: "Combat Gear", url: "/collections/combat-gear" },
            { name: "Pouches", url: "/collections/pouches" }
        ];

        var navList = document.querySelector('.contents.unstyled-list');
        var firstNavItem = navList.querySelector('li.header__primary-nav-item');

        // Idempotent: executePageUpdates can now run more than once per page
        // (offline apply + the session blender's re-apply) - without this
        // guard every extra run inserted the three items again.
        if (navList.querySelector('li[data-agb-nav-added]')) return;
        if (firstNavItem) {
            collectionsToAdd.forEach(function(collection) {
               var newNavItem = document.createElement('li');
                newNavItem.classList.add('header__primary-nav-item');
                newNavItem.setAttribute('data-agb-nav-added', '1');
                newNavItem.innerHTML = `<a href="${collection.url}" class="block h5">${collection.name}</a>`;
                firstNavItem.insertAdjacentElement('afterend', newNavItem);
                firstNavItem = newNavItem;  // Update firstNavItem to ensure items are added sequentially
            });
        } else {
            console.error("First navigation item not found.");
        }
    }
    // Function to update the announcement bar
    function updateAnnouncementBar(country) {
        if (country && !['United States', 'USA', 'United States of America'].includes(country)) {
            var announcementBar = document.querySelector('.announcement-bar__carousel .prose');
            if (announcementBar) {
                announcementBar.textContent = `Great news! We ship directly to ${country}`;
            }
        }
    }
    // Function to hide section if tande equals 1
    function hideSectionIfTandeIs1(tande) {
        if (tande === "1") {
            var sectionToHide = document.querySelector('#shopify-section-template--17190971506940__e444e81a-0e07-46c5-b5f3-29850ec61577');
            if (sectionToHide) {
                sectionToHide.style.display = 'none';
            }
        }
    }
    // Function to reorder product list based on recommendations
    function reorderProductList(recommendedProducts) {
        if (!Array.isArray(recommendedProducts) || recommendedProducts.length === 0) return;
        var productListContainer = document.querySelector('#featured-collections-product-list-carousel-template--17094519816444__ec64810e-9fe1-4330-9c9d-6b05ac253e2e-collection-1');

        if (productListContainer) {
            let productCards = Array.from(productListContainer.querySelectorAll('product-card'));

            // Sorting product cards based on their position in recommendedProducts
            let sortedProductCards = productCards.sort((a, b) => {
                let handleA = a.getAttribute('handle');
                let handleB = b.getAttribute('handle');

                let indexA = recommendedProducts.findIndex(prod => prod.productLink === handleA);
                let indexB = recommendedProducts.findIndex(prod => prod.productLink === handleB);

                if (indexA === -1) indexA = Infinity; // Move non-recommended products to the end
                if (indexB === -1) indexB = Infinity;

                return indexA - indexB;
            });

            // Create a DocumentFragment to improve performance and avoid multiple reflows
            let fragment = document.createDocumentFragment();
            sortedProductCards.forEach(card => {
                fragment.appendChild(card);
            });

            // Clear the container and re-append the sorted cards
            productListContainer.innerHTML = ''; // Clear current content
            productListContainer.appendChild(fragment); // Append sorted products

            // Force the layout to repaint (browser hack to force the change)
            productListContainer.style.display = 'none';
            productListContainer.offsetHeight; // This forces a reflow/repaint
            productListContainer.style.display = '';

            // Optional: Re-initialize the carousel if applicable
            if (typeof refreshCarousel === 'function') {
                refreshCarousel();
            }

            console.log("Product list reordered successfully.");
        } else {
            console.error('Product list container not found.');
        }
}
    // Function to reorder collections based on recommended collections
    function reorderCollections(recommendedProducts) {
        if (!Array.isArray(recommendedProducts) || recommendedProducts.length === 0) return;
        // Get a list of recommended collections from the recommended products
        let recommendedCollections = [...new Set(recommendedProducts.map(product => product.collection))];

        // Select the collection list container
        let collectionList = document.querySelector('.collection-list');
        if (!collectionList) return;

        // Get all collection cards inside the collection list container
        let collectionCards = Array.from(collectionList.querySelectorAll('.collection-card'));

        // Sort collection cards based on whether they are recommended or not
        let sortedCollectionCards = collectionCards.sort((a, b) => {
            let hrefA = a.getAttribute('href');
            let hrefB = b.getAttribute('href');

            let isARecommended = recommendedCollections.includes(hrefA);
            let isBRecommended = recommendedCollections.includes(hrefB);

            // Recommended collections should come first
            if (isARecommended && !isBRecommended) {
                return -1;
            }
            if (!isARecommended && isBRecommended) {
                return 1;
            }
            return 0; // Keep original order if both are recommended or both are not
        });

        // Clear the collection list container and re-append the sorted collection cards
        collectionList.innerHTML = '';
        sortedCollectionCards.forEach(function (collection) {
            collectionList.appendChild(collection);
        });

        console.log('Collections reordered successfully.');
}
    // Function to update the first slideshow image
    function updateSlideshow(firstProduct) {
        // Extract relevant properties from the first recommended product
        let productHandle = firstProduct.productLink;
        let desktopImage = firstProduct.desktopBannerHTML;
        let mobileImage = firstProduct.mobileBannerHTML;
        let productUrl = `/products/${productHandle}`;

        // Update the slideshow with the images and URL of the first recommended product
        updateSlideshowImage(0, desktopImage, mobileImage, productUrl);
}
    // Function to update the slideshow image by index
    function updateSlideshowImage(slideIndex, desktopImage, mobileImage, productUrl) {
        // Select all slideshow slide elements
        let slides = document.querySelectorAll('.slideshow__slide');

        if (slides && slides[slideIndex]) {
            let slide = slides[slideIndex];

            // Update the link of the slide
            let slideLink = slide.querySelector('a');
            if (slideLink) {
                slideLink.setAttribute('href', productUrl);
            }

            // Update the mobile image source
            let mobileSource = slide.querySelector('source[media="(max-width: 699px)"]');
            if (mobileSource && mobileImage) {
                mobileSource.setAttribute('srcset', mobileImage);
            }

            // Update the desktop image
            let desktopImg = slide.querySelector('img');
            if (desktopImg && desktopImage) {
                desktopImg.setAttribute('src', desktopImage);
                desktopImg.setAttribute('srcset', desktopImage);
            }
        } else {
            console.warn('Slide not found for index:', slideIndex);
        }
}
    // Function to update product images based on the recommended color
    function revealBadgesByPositions(recommendedProducts, positions) {
        if (!Array.isArray(recommendedProducts)) return;

        positions.forEach(function(pos) {
            // only if within bounds
            if (pos >= 0 && pos < recommendedProducts.length) {
            var handle = recommendedProducts[pos].productLink;
            var badgeEl = document.querySelector(
                '.product-card[handle="' + handle + '"] .product-card__badge'
            );
            if (badgeEl) badgeEl.classList.remove('badge--hidden');
            }
        });
}

});
